import store from '@/store'

export const mostrarIdioma = (s) => {
    let mostrar = Array.isArray(s) ? s.find(e => e.lang == store.state.langDefecto) : null
    if (mostrar && mostrar.text) {
        if (mostrar.text.length > 0) {
            return mostrar.text
        } else {
            return '';
        }
    } else if (mostrar === null) {
        return s

    } else {
        return ''
    }
}

export const createSlug = (str) => {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to = "aaaaaeeeeiiiioooouuuunc------";

    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

export const randomString = (length) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export const mostrarMoneda = function (cantidad, zero = false) {
    return (cantidad) ? redondeo(cantidad).toFixed(2) : ((zero) ? Number.parseFloat(cantidad).toFixed(2) : '0.00');
}

export const redondeo = (num) => {
    return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100
}

export const idToTexto = (s) => {
    return (s && s.length > 0) ? s.replace(/^./, s[0].toUpperCase()).replace(/_/g, ' ').replace(/-/g, ' ') : '';
}